var React = require('react');

function Dollar (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13.3 10.6V4.5c1.3.3 2.5.9 3.6 1.8l.2.2.1-.2 1.1-1.6.1-.2-.2-.1c-1.7-1.3-3.2-2-5-2.2v-2H11v1.9c-3 .3-5.3 2.3-5.3 5.1v.1c0 2.8 1.6 4.4 5.7 5.3v6.2c-1.7-.2-3.2-1-4.8-2.4l-.2-.2-.2.2L5 18l-.1.2.2.1c1.9 1.6 3.9 2.5 6.2 2.8v2.7h2.2v-2.6c3.4-.3 5.7-2.4 5.7-5.2v-.1c-.1-2.8-1.8-4.4-5.9-5.3zm3.3 5.4c0 1.6-1.3 2.7-3.2 2.9v-5.8c2.7.7 3.2 1.6 3.2 2.9zM8.2 7.2c0-1.6 1.3-2.6 3.2-2.8v5.7c-2.7-.7-3.2-1.7-3.2-2.9z"}));
}

Dollar.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Dollar;

Dollar.default = Dollar;
